import moment from "moment";
import React from "react";
import * as RB from "react-bootstrap";

function LogModal({ show, onHide, logs }) {
  return (
    <RB.Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <RB.Modal.Header closeButton>
        <RB.Modal.Title>CER Logs</RB.Modal.Title>
      </RB.Modal.Header>
      <RB.Modal.Body>
        <section className="bsb-timeline-1 py-3">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">
                <ul className="timeline">
                  {logs && logs.length > 0 ? (
                    logs
                      .sort(
                        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                      )
                      .map((log) => (
                        <li className="timeline-item" key={log.id}>
                          <div className="timeline-body">
                            <div className="timeline-content">
                              <div className="card border-0 mb-0">
                                <div className="card-body p-0">
                                  <h5 className="card-subtitle text-secondary mb-1">
                                    {moment(log.createdAt).format(
                                      "DD/MM/YYYY HH:mm"
                                    )}
                                  </h5>
                                  <p className="card-text mb-0">{log.note}</p>
                                  {/* <h4 className="card-title mb-1"> */}
                                  {log.reject_reason && (
                                    <p
                                      className={`card-text ${
                                        log.reject_reason
                                          .toLowerCase()
                                          .includes("hold")
                                          ? "text-warning"
                                          : "text-danger"
                                      }`}
                                    >
                                      <strong>{log.reject_reason
                                          .toLowerCase()
                                          .includes("hold")
                                          ? "Hold"
                                          : "Reject"} Reason:</strong>{" "}
                                      {log.reject_reason}
                                    </p>
                                  )}
                                  {/* </h4> */}
                                  {log.user_name} ({log.roleName})
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      ))
                  ) : (
                    <p>No logs available.</p>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </section>
      </RB.Modal.Body>
      <RB.Modal.Footer>
        <RB.Button variant="secondary" onClick={onHide}>
          Close
        </RB.Button>
      </RB.Modal.Footer>
    </RB.Modal>
  );
}

export default LogModal;
